// We need jQuery
var $ = window.jQuery;

export default {
  init() {
    // JavaScript to be fired on contact page page
  },
  loaded() {
    // Javascript to be fired on page once fully loaded
    $('#search-contacts-by-status .btn').on('click', function(){
      $(this).children('input').prop('checked', true);
      $(this).closest('form').submit();
    })

    $('.new-x').on('click', function() {
      $(this).fadeOut();
      $.ajax({
        url: tofinoJS.ajaxUrl,
        type: 'POST',
        data: {
          action: 'closeNew',
          value: $(this).data('id')
        },
        dataType: 'json',
        success: function (response) {
          if(response.success) {
            console.log(response.id) + 'not assigned_new';
          }
        }
      })
    })
  }
};
